export module SubstitutionBoardEnum {
    export enum SortOrder {
        None = 0,
        Asc = 1,
        Desc = 2
    }
}
